import React from 'react'
import { SubtractAlt16, AddFilled16 } from '@carbon/icons-react'
import { Tag } from 'carbon-components-react'


export default ({inward, suffix, customOutward, customInward}) => (
    <Tag renderIcon={!inward ? SubtractAlt16 : AddFilled16} style={{color: !inward ? 'red' : 'green'}}>
        {!inward ? (customOutward ? customOutward : "Outward") : (customInward ? customInward : "Inward")} {suffix}
    </Tag>
)